import * as React from 'react';

const SvgLogo = (props) => (
  <svg width={82} height={82} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      className="fill-black dark:fill-white"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.396 51.536h15.871v7.376H27.732V52.21l10.442-11.56-10.392-10.83v-6.722h26.485v7.374H38.733l9.633 10.087-9.97 10.978Z"
    />
    <path
      className="fill-black dark:fill-white"
      d="m41 7.462 23.719 9.823 9.824 23.72-9.824 23.72-23.72 9.825-23.719-9.826-9.825-23.72 9.825-23.719L41 7.462ZM41 0c-.422 0-.84.083-1.23.244l-26.718 11.07a3.209 3.209 0 0 0-1.738 1.737L.244 39.771a3.212 3.212 0 0 0 0 2.457l11.07 26.719a3.203 3.203 0 0 0 1.738 1.737l26.719 11.07a3.191 3.191 0 0 0 2.457 0l26.72-11.07a3.208 3.208 0 0 0 1.737-1.737l11.07-26.72a3.212 3.212 0 0 0 0-2.457l-11.07-26.719a3.215 3.215 0 0 0-1.738-1.737L42.228.244A3.234 3.234 0 0 0 41 0Z"
    />
  </svg>
);

export default SvgLogo;
